const NanoEvents = require('nanoevents');

export class Sandwich {
    constructor(buttonRoot) {
        this.button = {};
        this.button.root = buttonRoot;

        this._emitter = new NanoEvents();

        this._initButton();
    }

    get opened() {
        if (typeof this._opened === 'undefined') {
            this._opened = false;
        }
        return this._opened;
    }

    set opened(opened) {
        opened = !!opened;

        const status = opened ? 'opened' : 'closed';

        this._emitter.emit('change', status);

        if (opened) {
            this.button.button.classList.add('opened');
            this._emitter.emit('open');
        } else {
            this.button.button.classList.remove('opened');
            this._emitter.emit('close');
        }

        if (opened !== this._opened) {
            this._emitter.emit('toggle', status);
        }

        return this._opened = opened;
    }

    on() {
        return this._emitter.on.call(this._emitter, ...arguments);
    }

    _initButton() {
        const button = document.createElement('div');
        button.className = 'sandwich';
        button.innerHTML = '<span></span><span></span><span></span>';

        button.addEventListener('click', () => {
            const opened = !this.opened;
            this.opened = opened;
        });

        this.button.button = button;
        this.button.root.appendChild(button);
    }
}


// WEBPACK FOOTER //
// ./js/sandwich.js